import React, { createContext, useContext, useMemo } from "react";
import { useToastState } from "../ui/composites/use-toast";
import { ToastViewport } from "../ui/composites/toast-viewport";

const ToastContext = createContext(null);

/** App-wide toast notifications — mount once in AuthenticatedLayout. */
export default function ToastProvider({ children }) {
  const toast = useToastState();

  const api = useMemo(
    () => ({
      success: toast.success,
      error: toast.error,
      info: toast.info,
      created: toast.created,
      updated: toast.updated,
      deleted: toast.deleted,
      saved: toast.saved,
      createFailed: toast.createFailed,
      updateFailed: toast.updateFailed,
      deleteFailed: toast.deleteFailed,
      genericError: toast.genericError,
      suspended: toast.suspended,
      suspendFailed: toast.suspendFailed,
      dismiss: toast.dismiss,
    }),
    [toast]
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      <ToastViewport toasts={toast.toasts} onDismiss={toast.dismiss} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
